import script from "./IntroDuction009.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroDuction009.vue?vue&type=script&setup=true&lang=js"

import "./IntroDuction009.vue?vue&type=style&index=0&id=41baa590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41baa590"]])

export default __exports__